import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  ApiKeyInfoResponse,
  ApiKeyMutationResponse
} from '@/app/common/api/types/apiKeyApiTypes';

const apiKeyApi = createApi({
  reducerPath: 'apiKeyApi',
  baseQuery: (...args) => customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['ApiKey'],
  endpoints: build => ({
    getApiKeyInfo: build.query<ApiKeyInfoResponse, void>({
      query: () => ({
        url: '/go_handler/v2/user/api-key/info',
        method: 'POST'
      }),
      providesTags: ['ApiKey']
    }),
    generateApiKey: build.mutation<ApiKeyMutationResponse, void>({
      query: () => ({
        url: '/go_handler/v2/user/api-key/generate',
        method: 'POST'
      }),
      invalidatesTags: ['ApiKey']
    }),
    deleteApiKey: build.mutation<ApiKeyMutationResponse, void>({
      query: () => ({
        url: '/go_handler/v2/user/api-key/delete',
        method: 'POST'
      }),
      invalidatesTags: ['ApiKey']
    })
  })
});

export const {
  useGetApiKeyInfoQuery,
  useGenerateApiKeyMutation,
  useDeleteApiKeyMutation
} = apiKeyApi;

export default apiKeyApi;
